/**
 * import and init third party
 * components/validators and other dependencies
 */

import Vue from 'vue'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

Vue.use(VueMaterial)
